(() => {
  if (!customElements.get('gr-brand-carousel')) customElements.define('gr-brand-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.slides = [...this.querySelectorAll('[data-gr-slide]')];
      this.dots = [...this.querySelectorAll('[data-gr-slide-index]')];
      this.index = 0;
      this.show = (index) => {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; slide.inert = i !== this.index; });
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
      };
      this.stop = () => { clearInterval(this.timer); this.timer = null; };
      this.addEventListener('click', event => {
        const control = event.target.closest('[data-gr-slide-index], [data-gr-slide-direction]');
        if (!control) return;
        this.stop();
        this.show(control.hasAttribute('data-gr-slide-index') ? Number(control.dataset.grSlideIndex) : this.index + Number(control.dataset.grSlideDirection));
      });
      this.addEventListener('pointerdown', event => { this.start = { x: event.clientX, y: event.clientY }; });
      this.addEventListener('pointercancel', () => { this.start = null; });
      this.addEventListener('pointerup', event => {
        if (!this.start || event.target.closest('a,button')) return;
        const dx = event.clientX - this.start.x;
        if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(event.clientY - this.start.y)) { this.stop(); this.show(this.index + (dx < 0 ? 1 : -1)); }
        this.start = null;
      });
      this.addEventListener('focusin', this.stop);
      this.addEventListener('mouseenter', this.stop);
      this.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) { this.stop(); this.show(index); }
      });
      const pause = this.querySelector('[data-gr-pause]');
      pause?.addEventListener('click', () => { this.stop(); pause.hidden = true; });
      if (this.dataset.autoplay === 'true' && this.slides.length > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches && !window.Shopify?.designMode) {
        this.timer = setInterval(() => this.show(this.index + 1), 6000);
        if (pause) pause.hidden = false;
      }
      this.show(0);
    }
    disconnectedCallback() { this.stop?.(); }
  });
  let cardSequence = 0;
  if (!customElements.get('gr-brand-product')) customElements.define('gr-brand-product', class extends HTMLElement {
    static alignRows() {
      if (this.alignmentFrame) return;
      this.alignmentFrame = requestAnimationFrame(() => {
        this.alignmentFrame = null;
        const groups = new Map();
        document.querySelectorAll('gr-brand-product').forEach(card => {
          card.style.removeProperty('--gr-card-title-height');
          const group = card.closest('.gr-brand-grid, .gr-home-product-row, .gr-collection-grid, .gr-search__grid, .gr-products__grid, .product-grid, .gr-product-upsells__grid, .gr-cart-recommendations__grid, .gr-product-recent__grid');
          if (!group || !card.getClientRects().length) return;
          if (!groups.has(group)) groups.set(group, []);
          groups.get(group).push(card);
        });
        groups.forEach(cards => {
          const rows = new Map();
          cards.forEach(card => {
            const top = Math.round(card.getBoundingClientRect().top);
            if (!rows.has(top)) rows.set(top, []);
            rows.get(top).push(card);
          });
          rows.forEach(row => {
            const height = Math.max(...row.map(card => card.querySelector('h3').getBoundingClientRect().height));
            row.forEach(card => card.style.setProperty('--gr-card-title-height', height + 'px'));
          });
        });
      });
    }
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.resizeObserver = new ResizeObserver(entries => {
        const width = entries[0].contentRect.width;
        if (width !== this.lastWidth) { this.lastWidth = width; this.constructor.alignRows(); }
      });
      this.resizeObserver.observe(this);
      document.fonts.ready.then(() => this.constructor.alignRows());
      this.constructor.alignRows();
      const instance = ++cardSequence;
      const form = this.querySelector('form');
      if (form) form.setAttribute('id', form.getAttribute('id') + '-' + instance);
      const variantControl = this.querySelector('[data-gr-variant]');
      if (variantControl) {
        variantControl.id += '-' + instance;
        this.querySelector('label').htmlFor = variantControl.id;
      }
      this.querySelector('[data-gr-image-toggle]')?.addEventListener('click', event => {
        const button = event.currentTarget;
        const alternate = button.getAttribute('aria-pressed') !== 'true';
        button.setAttribute('aria-pressed', String(alternate));
        this.toggleAttribute('data-alternate', alternate);
      });
      const select = this.querySelector('[data-gr-variant]');
      select?.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const button = this.querySelector('[name="add"]');
        const price = this.querySelector('[data-gr-price]');
        button.disabled = !select.value || option.disabled;
        if (option.dataset.price && price) price.innerHTML = option.dataset.price;
        const quantity = this.querySelector('[name="quantity"]');
        if (quantity) quantity.value = option.dataset.quantity || '1';
        this.querySelectorAll('[data-gr-product-link]').forEach(link => {
          const url = new URL(link.href);
          if (select.value) url.searchParams.set('variant', select.value);
          else url.searchParams.delete('variant');
          link.href = url.href;
        });
        this.querySelector('.product-form__error-message-wrapper')?.setAttribute('hidden', '');
      });
    }
    disconnectedCallback() { this.resizeObserver?.disconnect(); }
  });
  if (!customElements.get('gr-brand-story')) customElements.define('gr-brand-story', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.querySelector('[data-gr-play]')?.addEventListener('click', event => {
        const template = this.querySelector('template');
        if (!template) return;
        const stage = this.querySelector('[data-gr-story-media]');
        stage.replaceChildren(template.content.cloneNode(true));
        const video = stage.querySelector('video');
        if (video) { video.focus(); video.play().catch(() => {}); }
        stage.querySelector('iframe')?.focus();
      }, { once: true });
    }
  });
})();
